<!-- 编辑储值卡支付金额 -->
<template>
  <van-popup v-model="show" round position="bottom" closeable @close="close" :style="{ height: '40%' }" :safe-area-inset-bottom="true">
    <div class="e-wallet-edit-popup">
      <div class="title">{{ title }}</div>
      <div class="more-account-wrapper">
        <van-cell
          center
          class="more-account-item"
          :border="false"
        >
          <template #title>支付金额：</template>
          <template #label>可用余额￥{{ totalAvailableMoney | formatNumber }}</template>
          <template>
            <van-field
              class="input"
              v-model="useNum"
              input-align="right"
              type="number"
              placeholder="请输入金额"
              :formatter="app.tool.format2MaxWrap(canuseNum)"
            />
          </template>
        </van-cell>
      </div>
      <page-footer-btn multipleBtns>
        <van-button
          square
          round
          block
          type="primary"
          @click="dosomething"
        >
          确认：{{ useNum | formatNumber }}
        </van-button>
      </page-footer-btn>
    </div>
  </van-popup>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'e-wallet-edit-popup',
  data() {
    return {
      show: false,
      remainMoney: 0,
      useNum: 0,
      totalAvailableMoney: 0,
      title: '电子钱包支付',
    };
  },
  components: {
    pageFooterBtn,
  },
  computed: {
    // 默认能支付的金额
    canuseNum() {
      let num = 0;
      if (this.remainMoney > 0) {
        if (this.remainMoney > this.totalAvailableMoney) {
          num = this.totalAvailableMoney;
        } else {
          num = this.remainMoney;
        }
      }
      return num;
    },
  },
  methods: {
    dosomething() {
      this._rsv &&
      this._rsv({
        updateMoney: this.useNum,
      });
      this.show = false;
    },
    // 已选的金额，剩余可支付的金额，可用的金额，展示的标题
    open({ useNum, remainMoney, totalAvailableMoney, title }) {
      this.show = true;
      this.useNum = useNum;
      this.remainMoney = remainMoney;
      this.totalAvailableMoney = totalAvailableMoney;
      this.title = title;

      return new Promise((rsv, rej) => {
        this._rsv = rsv;
        this._rej = rej;
      });
    },
    close() {
      this._rej && this._rej();
    },
  },
};
</script>

<style lang="scss" scoped>
.e-wallet-edit-popup {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.title {
  height: 44px;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  color: var(--g8);
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}
.more-account-wrapper {
  overflow: auto;
  flex: 1 1 auto;
  .more-account-item {
    padding: 6px 16px;
    height: 50px;
    ::v-deep .input {
      border: 1px solid var(--g3);
      padding: 5px 12px;
      border-radius: 8px;
    }
    ::v-deep .van-cell__value {
      flex: 0 0 auto;
    }
    ::v-deep input {
      width: 96px;
    }
  }
}
</style>